import Result from "@/core/common/Result";
import { inject, injectable } from "inversify";
import {
  type IPodeVisualizarPesquisaCSATUseCase,
  podeVisualizarPesquisaCSATUseCaseDI
} from "./ports/PodeVisualizarPesquisaCSATUseCase";
import "reflect-metadata";
import {
  ignorarPesquisaCSATUseCaseDI,
  type IIgnorarPesquisaCSATUseCase
} from "./ports/IgnorarPesquisaCSATUseCase";

@injectable()
export abstract class AbstractCSAT<T> {
  private currentPage = 1;
  private maxPage = 1;
  abstract state: T;

  @inject(podeVisualizarPesquisaCSATUseCaseDI)
  protected readonly podeVisualizarPesquisaUseCase!: IPodeVisualizarPesquisaCSATUseCase;

  @inject(ignorarPesquisaCSATUseCaseDI)
  protected readonly ignorarPesquisaUseCase!: IIgnorarPesquisaCSATUseCase;

  abstract sendCSAT(): Promise<Result<void>>;

  abstract podeVisualizarPesquisa(): Promise<boolean>;

  protected setMaxPage(maxPage: number) {
    this.maxPage = maxPage;
  }

  setNextPage(page: number) {
    this.currentPage = page;
  }

  isLastPage(): boolean {
    return this.currentPage >= this.maxPage;
  }

  getCurrentPage(): number {
    return this.currentPage;
  }

  backPage() {
    this.currentPage -= 1;
  }

  nextPage() {
    this.currentPage += 1;
  }
}
